import { Injectable } from '@angular/core';
import { PageService } from './page.service';
import { RouteService } from './route.service';
import { environment } from '../../environments/environment';
import { ApplicationStateService } from './application-state.service';

@Injectable({
    providedIn: 'root'
})
export class PageExportService {

    constructor(private pageService: PageService,
                private applicationStateService: ApplicationStateService,
                private routeService: RouteService) {
    }

    getCurrentPagesDownloadLink(): Promise<string> {
        let currentPagesIndizes = [];

        return new Promise((resolve, reject) => {
            currentPagesIndizes = this.pageService.getCurrentPages().map(page => {
                return page.index;
            });

            resolve(this.getDownloadURL(currentPagesIndizes));
        });
    }

    getCurrentLeftPageDownloadLink(): Promise<string> {
        let currentPagesIndizes = [];

        return new Promise((resolve, reject) => {
            currentPagesIndizes = this.pageService.getCurrentPages().slice(0, 1).map(page => {
                return page.index;
            });

            resolve(this.getDownloadURL(currentPagesIndizes));
        });
    }

    getCurrentRightPageDownloadLink(): Promise<string> {
        let currentPagesIndizes = [];

        return new Promise((resolve, reject) => {
            currentPagesIndizes = this.pageService.getCurrentPages().slice(1).map(page => {
                return page.index;
            });

            resolve(this.getDownloadURL(currentPagesIndizes));
        });
    }

    getCurrentDoublePageDownloadLink(): Promise<string> {
        return new Promise((resolve, reject) => {

            const currentIndex = this.applicationStateService.currentIndex;
            const pagesToDownload = 2;
            const indexOfFirstDoublePage = 1;
            const firstIndexToDownload = currentIndex - ((Math.max(currentIndex - indexOfFirstDoublePage, 0)) % pagesToDownload);
            const secondIndexToDownload = firstIndexToDownload + 1;
            let currentPagesIndizes = [firstIndexToDownload, secondIndexToDownload];

            if (firstIndexToDownload === 0 || firstIndexToDownload === this.pageService.getHighestIndex()) {
                currentPagesIndizes = currentPagesIndizes.slice(0, 1);
            }

            resolve(this.getDownloadURL(currentPagesIndizes));
        });
    }

    private getDownloadURL(pageIndizes: Array<number>): string {

        let param = '?';
        pageIndizes.forEach(ele => {
            param = `${param}index[]=${ele}&`;
        });

        const route = this.routeService.getRelativeRoute(environment.endpointUrls.downloadPages, {
            bookId: this.applicationStateService.bookId
        });

        return route + param;
    }

}
